import { Component, OnDestroy, ChangeDetectionStrategy, inject } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';
import { Store } from '@ngrx/store';
import { filter, Observable, Subject, takeUntil } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { RootState } from './@core/interfaces/store/_index.store';
import * as FromUser from './@core/interfaces/store/_index.store';
import { MenuService } from './@core/services/_index-core.services';

@Component({
  selector: 'tgx-admin',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnDestroy {
  private store = inject<Store<RootState>>(Store);
  private menuService = inject(MenuService);
  private router = inject(Router);

  protected showBearerCopied = false;
  accessToken$: Observable<string> = this.store.select(FromUser.selectAccessToken);

  private destroy$ = new Subject<void>();

  menu: NbMenuItem[] = [];

  constructor() {
    this.menuService.menu.pipe(takeUntil(this.destroy$)).subscribe((menu) => {
      this.menu = menu;
      this.expandActiveMenu();
      if (this.menu.length > 0) {
        if (this.menu.findIndex((x) => x.title === 'Back Home') > -1 && this.menu.length > 1) {
          this.menu[2].expanded = true;
          this.menu[2].children[0].selected = true;
        } else if (this.menu.findIndex((x) => x.selected === true) === -1) {
          this.menu[1].selected = true;
        }
      }
    });
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        this.expandActiveMenu();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected handleCopyBearer(copied: boolean) {
    this.showBearerCopied = copied;
  }

  private expandActiveMenu(): void {
    const currentUrl = this.router.url.split('?')[0];

    const expandAncestors = (items: NbMenuItem[]): boolean =>
      items.some((item) => {
        const isActive = item.link === currentUrl;
        const hasActiveChild = item.children ? expandAncestors(item.children) : false;
        item.expanded = hasActiveChild;
        return isActive || hasActiveChild;
      });

    expandAncestors(this.menu);
  }
}
